import { render, staticRenderFns } from "./ContributorsViewCard.vue?vue&type=template&id=100aa2ec"
import script from "./ContributorsViewCard.vue?vue&type=script&lang=js"
export * from "./ContributorsViewCard.vue?vue&type=script&lang=js"
import style0 from "./ContributorsViewCard.vue?vue&type=style&index=0&id=100aa2ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports